import { StringParam, useQueryParam, withDefault } from 'use-query-params';
import React, { useState, useEffect } from 'react';
import {
  BOLT_STEPS,
  CERTAIN_STEPS,
  SERVER_STEPS,
  STEPS,
  STEPS_PAGE_TITLES,
} from '../constants';
import {
  STEPS_FOUR_STAGES,
  STEPS_PAGE_TITLES_FOUR_STAGES,
} from '../constants_four_stages';
import PcModelStepsStep from '../PcModelStepsStep';
import PcModelStepsStepMobile from '../PcModelStepsStepMobile';
import styles from './styles';
import { usePcConfigurator } from 'utils/PcConfiguratorContext';

const PcModelSteps = ({ uid, navbar, navbarTablet, navbarMobile, hasPanelPrints }) => {
  // let UPDATED_STEPS;

  // let isBolt = false;
  const [isBolt, setIsBolt] = useState(false);
  const [updatedSteps, setUpdatedSteps] = useState(STEPS);
  const [updatedStepsPageTitles, setUpdatedStepsPageTitles] = useState(STEPS_PAGE_TITLES);

  const isServer = uid === 'esc8000a-e12';

  useEffect(() => {
    if (hasPanelPrints) {
      setUpdatedSteps(BOLT_STEPS);
      setIsBolt(true);
    } else if (isServer) {
      setUpdatedSteps(SERVER_STEPS);
    } else {
      setUpdatedSteps(STEPS);
    }
  }, []);

  // if (
  //   (uid === 'bolt-lite' ||
  //   uid === 'bolt-test' ||
  //   uid === 'bolt' ||
  //   uid === 'bolt-plus') && hasPanelPrints
  // ) {
  //   UPDATED_STEPS = BOLT_STEPS;
  //   // setIsBolt(true);
  // }
  // if (isServer) {
  //   UPDATED_STEPS = SERVER_STEPS;
  // } else {
  //   UPDATED_STEPS = STEPS;
  // }

  // let UPDATED_STEPS_PAGE_TITLES = STEPS_PAGE_TITLES;

  const { options } = usePcConfigurator();
  const optionsFourStages = ['build', 'ultra-labs', 'accessories (new)'];
  // let isInArray = false;
  const [isInArray, setIsInArray] = useState(false);

  useEffect(() => {
    if (options?.length != 0) {
      setIsInArray(optionsFourStages.includes(options[0].group_step_new));
      if (isInArray) {
        setUpdatedSteps(STEPS_FOUR_STAGES);
        // UPDATED_STEPS = STEPS_FOUR_STAGES;
        setUpdatedStepsPageTitles(STEPS_PAGE_TITLES_FOUR_STAGES);
        // UPDATED_STEPS_PAGE_TITLES = STEPS_PAGE_TITLES_FOUR_STAGES;
      } else {
        if (isBolt && hasPanelPrints) {
          setUpdatedSteps(BOLT_STEPS);
        } else if (isServer) {
          setUpdatedSteps(SERVER_STEPS);
        } else {
          setUpdatedSteps(STEPS);
        }
        setUpdatedStepsPageTitles(STEPS_PAGE_TITLES);
      }
    }
  }, []);

  const [currentStep] = useQueryParam(
    'step',
    withDefault(StringParam, updatedSteps[0]),
  );

  const [currentIndex, setCurrentIndex] = useState(null);

  const findStepIndex = (step) =>
    updatedSteps.findIndex((item) => item === step);

  useEffect(() => {
    setCurrentIndex(findStepIndex(currentStep));
  }, [currentStep, updatedSteps]);
  
  return (
    <>
      <div className={`steps-container ${navbar ? 'fixed_nav' : ''}`}>
        <div className="pc-model-config-header wrapper">
          {updatedStepsPageTitles[currentStep]}
        </div>

        <div
          className={
            isInArray
              ? `steps step_4stages_${currentIndex}`
              : `steps step${currentIndex}`
          }
        >
          {updatedSteps.map((step) => {
            const index = findStepIndex(step);

            return (
              <>
                <PcModelStepsStep
                  key={step}
                  step={step}
                  completed={index < currentIndex}
                  active={index <= currentIndex}
                  currentStep={currentStep}
                  uid={uid}
                  isBolt={isBolt}
                />
              </>
            );
          })}
        </div>
      </div>

      <div
        className={`steps-container-tablet ${
          navbarTablet ? 'fixed_nav_tablet' : ''
        }`}
      >
        <div className="pc-model-config-header wrapper">
          {updatedStepsPageTitles[currentStep]}
        </div>

        <div
          className={
            isInArray
              ? `steps step_4stages_${currentIndex}`
              : `steps step${currentIndex}`
          }
        >
          {updatedSteps.map((step) => {
            const index = findStepIndex(step);
            
            return (
              <>
                <PcModelStepsStep
                  key={step}
                  step={step}
                  completed={index < currentIndex}
                  active={index <= currentIndex}
                  currentStep={currentStep}
                  uid={uid}
                  isBolt={isBolt}
                />
              </>
            );
          })}
        </div>
      </div>

      <div
        className={`steps-container-mobile ${
          navbarMobile ? 'fixed_nav_mobile' : ''
        }`}
      >
        <div className="pc-model-config-header wrapper">
          {updatedStepsPageTitles[currentStep]}
        </div>

        <div
          className={
            isInArray
              ? `steps step_4stages_${currentIndex}`
              : `steps step${currentIndex}`
          }
        >
          {updatedSteps.map((step) => {
            const index = findStepIndex(step);

            return (
              <>
                <PcModelStepsStepMobile
                  key={step}
                  step={step}
                  completed={index < currentIndex}
                  active={index <= currentIndex}
                  currentStep={currentStep}
                  showTitle={index === currentIndex}
                  uid={uid}
                  isBolt={isBolt}
                />
              </>
            );
          })}
        </div>
      </div>
      {/* {['chassis', 'build'].includes(currentStep) && (
        <div className="old-steps-warning-container">
          <div className="old-steps-warning-text">
            We have updated the configurator. Sorry, the link you are using no
            longer works. Please use the new steps to build your Rig.
          </div>
        </div>
      )} */}

      <style jsx>{styles}</style>
      <style jsx>{`
        .steps {
          ${isBolt ? 'width: 95%; width: 60%;' : ''}
        }
        .step0:before {
          ${isBolt ? 'width: 16.5%;' : ''}
        }
        .step1:before {
          ${isBolt ? 'width: 34%;' : ''}
        }
        .step2:before {
          ${isBolt ? 'width: 50%;' : ''}
        }
        .step3:before {
          ${isBolt ? 'width: 67%;' : ''}
        }
        .step4:before {
          ${isBolt ? 'width: 85%;' : ''}
        }
        .step5:before {
          ${isBolt ? 'width: 100%;' : ''}
        }
        @media (max-width: 991px) {
          .steps {
            ${isBolt ? 'width: 95%;' : ''}
          }
          .step0:before {
            ${isBolt ? 'width: 17%;' : ''}
          }
          .step1:before {
            ${isBolt ? 'width: 34%;' : ''}
          }
          .step2:before {
            ${isBolt ? 'width: 50%;' : ''}
          }
          .step3:before {
            ${isBolt ? 'width: 67%;' : ''}
          }
          .step4:before {
            ${isBolt ? 'width: 85%;' : ''}
          }
          .step5:before {
            ${isBolt ? 'width: 100%;' : ''}
          }
        }
        @media (max-width: 874px) {
          .step3:before {
            ${isBolt ? 'width: 67%;' : ''}
          }
        }
        @media (max-width: 595px) {
          .steps {
            ${isBolt ? 'width: 300px;' : ''}
          }
          .step0:before {
            ${isBolt ? 'width: 23%;' : ''}
          }
          .step1:before {
            ${isBolt ? 'width: 41%;' : ''}
          }
          .step2:before {
            ${isBolt ? 'width: 55%;' : ''}
          }
          .step3:before {
            ${isBolt ? 'width: 72%;' : ''}
          }
          .step4:before {
            ${isBolt ? 'width: 86%;' : ''}
          }
          .step5:before {
            ${isBolt ? 'width: 100%;' : ''}
          }
        }
      `}</style>
      <style jsx>{`
        .steps {
          ${isServer ? 'gap: 70px;' : ''}
          ${isServer ? 'width: 400px;' : ''}
        }
        .step0:before {
          ${isServer ? 'width: 30%;' : ''}
        }
        .step1:before {
          ${isServer ? 'width: 68%;' : ''}
        }
        .step2:before {
          ${isServer ? 'width: 100%;' : ''}
        }
        @media (max-width: 595px) {
          .steps {
            ${isServer ? 'width: 200px;' : ''}
            ${isServer ? 'gap: 30px;' : ''}
          }
          .step0:before {
            ${isServer ? 'width: 38%;' : ''}
          }
          .step1:before {
            ${isServer ? 'width: 72%;' : ''}
          }
          .step2:before {
            ${isServer ? 'width: 100%;' : ''}
          }
        }
      `}</style>
    </>
  );
};

export default PcModelSteps;
